module.exports = __webpack_public_path__ + "static/img/can-watermelon.358fde6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-watermelon.png
// module id = 7OX6
// module chunks = 0